import { MessageCircle } from "lucide-react";
import { track } from "@/lib/tracker";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/32468063847?text=Hallo%20Seppe%2C%20ik%20wil%20graag%20meer%20info%20over%20jouw%20shows"
      target="_blank"
      rel="noreferrer"
      onClick={() => track("whatsapp_click")}
      className="fixed bottom-6 left-6 z-40 flex items-center gap-3 bg-[#25D366] text-white px-5 py-3.5 rounded-full shadow-2xl hover:scale-105 hover:-translate-y-1 transition-all duration-300 group"
      data-testid="whatsapp-float-button"
      aria-label="WhatsApp Magic Seppe"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-semibold tracking-wide">WhatsApp</span>
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping" />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full" />
    </a>
  );
}
